import React, { useEffect, useState } from 'react';
import { Mail, MapPin, Phone, ShieldCheck, UserRound } from 'lucide-react';
import { PerfilRapido } from '../types/perfil';
import { resolverUrlFotoPerfil } from './perfilUtils';

type Props = {
  perfil: PerfilRapido;
};

const Campo: React.FC<{ rotulo: string; valor?: string | null }> = ({ rotulo, valor }) => {
  if (!valor) return null;
  return (
    <div>
      <dt>{rotulo}</dt>
      <dd>{valor}</dd>
    </div>
  );
};

const PerfilRapidoCard: React.FC<Props> = ({ perfil }) => {
  const imagem = resolverUrlFotoPerfil(perfil.foto_url ?? perfil.imagem_url);
  const [imagemFalhou, setImagemFalhou] = useState(false);

  useEffect(() => setImagemFalhou(false), [imagem]);

  return (
    <article className="perfil-rapido-card">
      <header className="perfil-rapido-header">
        {imagem && !imagemFalhou ? (
          <img src={imagem} alt={`Foto de ${perfil.nome}`} onError={() => setImagemFalhou(true)} />
        ) : (
          <div className="perfil-rapido-avatar"><UserRound size={28} aria-hidden="true" /></div>
        )}
        <div>
          <span className="eyebrow">{perfil.tipo === 'tenant' ? 'Empresa tenant' : 'Fornecedor'}</span>
          <h2>{perfil.nome}</h2>
          <div className="perfil-rapido-badges">
            {perfil.estado && <span className="status-pill status-done"><ShieldCheck size={14} aria-hidden="true" />{perfil.estado}</span>}
            {perfil.status_perfil && (
              <span className={`status-pill ${perfil.status_perfil.completo ? 'status-done' : 'status-warning'}`}>
                {perfil.status_perfil.completo ? '✔ Perfil completo' : '⚠ Perfil incompleto'}
              </span>
            )}
          </div>
        </div>
      </header>

      <dl className="perfil-rapido-grid">
        <Campo rotulo="NIF" valor={perfil.nif} />
        <Campo rotulo="Telefone" valor={perfil.telefone} />
        <Campo rotulo="WhatsApp" valor={perfil.whatsapp} />
        <Campo rotulo="E-mail operacional" valor={perfil.email_operacional} />
        <Campo rotulo="Província" valor={perfil.provincia} />
        <Campo rotulo="Município" valor={perfil.municipio} />
        <Campo rotulo="Localização física" valor={perfil.endereco} />
        <Campo rotulo="Referência" valor={perfil.referencia} />
        <Campo rotulo="Contacto responsável" valor={perfil.contacto_responsavel} />
      </dl>

      <div className="perfil-rapido-actions">
        {perfil.telefone && <a className="botao" href={`tel:${perfil.telefone}`}><Phone size={16} aria-hidden="true" />Ligar</a>}
        {perfil.email_operacional && <a className="botao" href={`mailto:${perfil.email_operacional}`}><Mail size={16} aria-hidden="true" />E-mail</a>}
        {perfil.endereco && <span><MapPin size={16} aria-hidden="true" />{perfil.provincia || 'Localização'}{perfil.municipio ? `, ${perfil.municipio}` : ''}</span>}
      </div>
    </article>
  );
};

export default PerfilRapidoCard;
